import React, { useState, useEffect, useCallback, useRef } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import Constants from "../Utilities/Constants";
import ContactFormEmbed from "./ContactFormEmbed";

// Admin-authored page content (TinyMCE) can embed a widget by including an
// element with data-widget="<key>" (e.g. <div data-widget="contact-form"></div>).
// Add new embeddable widgets here to make them available in the page editor.
const WIDGETS = {
    "contact-form": ContactFormEmbed,
};

const PageContent = ({furl, onTitle}) => {
    const [page, setPage] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const containerRef = useRef(null);
    const [widgetMounts, setWidgetMounts] = useState([]);

    const fetchPage = useCallback(async () => {
        var url = `${Constants.API_URL_GET_PAGE}/${furl}`;

        try {
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            //alert("לא ניתן להתחבר לשרת");
            return null;
        }
    }, [furl]);

    useEffect(() => {

        const fetchAndSetPage = async () => {
            setIsLoading(true);
            const content = await fetchPage();
            setPage(content);
            if (content?.pageName && onTitle) onTitle(content.pageName);
            setIsLoading(false);
        };

        fetchAndSetPage();

    }, [fetchPage]);

    // The page HTML is injected via dangerouslySetInnerHTML, so widget mount
    // points only exist in the DOM after that render commits - scan for them
    // here and portal the matching React component into each one.
    useEffect(() => {
        if (!containerRef.current) {
            setWidgetMounts([]);
            return;
        }
        const nodes = Array.from(containerRef.current.querySelectorAll('[data-widget]'))
            .filter(node => WIDGETS[node.dataset.widget]);
        setWidgetMounts(nodes);
    }, [page]);


      if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        page &&
        <>
            <div ref={containerRef} dangerouslySetInnerHTML={{ __html: page.pageContent }} />
            {widgetMounts.map((node, i) => {
                const Widget = WIDGETS[node.dataset.widget];
                return createPortal(<Widget key={i} />, node);
            })}
        </>
    )
}

export default PageContent;
